import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { Heading, BodyText, List, ListItem, TileRadioGroup, TileRadio, GridRow, GridCol, Button } from '@lmig/lmds-react';
import { FormContext } from '../FormContext/FormContext';
import { PERSONA_MODAL } from '../constants';

const WelcomePage = () => {
  const [values, handleSetValues] = useContext(FormContext);

  return (
    <div className='supplement-container'>
      <Box style={{ padding: '20px' }}>
        <Heading type="h2-light">
          {PERSONA_MODAL.HEADER}
        </Heading>
        <BodyText type='article-medium' 
          style={{ fontFamily: '"Roboto",Arial,sans-serif', fontSize: '16px' }}>
            <span style={{ fontWeight: 700 }} >Changes to estimates happen. </span>
          <span style={{ fontWeight: 400 }}>Submit a supplement for quick revisions.</span></BodyText>

        <BodyText type="article-medium" 
        style={{ paddingTop: '20px', fontFamily: '"Roboto",Arial,sans-serif',fontSize: '16px' }}>
          <p style={{ fontWeight: 700 }}>What you need:</p></BodyText>

        <List>
          <ListItem>Claim number</ListItem>
          <ListItem>Original estimate amount</ListItem>
          <ListItem>Updated costs or “supplement amounts”</ListItem>
          <ListItem>Supporting files like photos or receipts (optional)</ListItem>
        </List>

        <BodyText type="article" style={{ fontFamily: '"Roboto",Arial,sans-serif', fontSize: '16px' }}>Before continuing,
          please tell us about yourself.</BodyText>


        <TileRadioGroup
          name="radioGroup--persona"
          value={values.contactPersona}
          onChange={(e) => handleSetValues('persona', e)}
        >
          <GridRow gutters style={{ marginTop: '10px' }}>
            <GridCol base={12} md={3} sm={4}>
              <TileRadio defaultChecked={values.contactPersona === 'Policyholder'} 
              labelVisual="I'm a policyholder" value="Policyholder" />
            </GridCol>
            <GridCol base={12} md={3} sm={4}>
              <TileRadio defaultChecked={values.contactPersona === 'Contractor'} labelVisual="I'm a contractor" value="Contractor" />
            </GridCol>
          </GridRow>
          <GridRow gutters style={{ marginBottom: '12px' }}>
            <GridCol base={12} md={3} sm={4}>
              <TileRadio defaultChecked={values.contactPersona === 'Other'} labelVisual="Other" value="Other" />
            </GridCol>
          </GridRow>
        </TileRadioGroup>

        <Button variant="primary" style={{ marginTop: '20px' }} size="large" onClick={(e) => handleSetValues('personaSelected', e)}>
          Let&apos;s get started
        </Button>
      </Box>
    </div>

  );
};

export default WelcomePage;
